import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function HotSection() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <span className="text-xs font-semibold text-red-500 uppercase tracking-wider">🔥 Trending</span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-1 font-heading">
              <strong>热门作品</strong>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">当下最火爆的韩国漫画，大家都在看</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}